module.exports = __webpack_public_path__ + "static/media/10.269f2427.jpg";